export interface ICuota {
  id?: string;
  nombre?: string;
}

export class Cuota implements ICuota {
  constructor(public id?: string, public nombre?: string) {}
}

export interface IMenuCuota {
  value?: ICuota;
  text?: string;
}

export class MenuCuota implements IMenuCuota {
  constructor(public value?: ICuota, public text?: string) {}
  static fromObject(item: ICuota): MenuCuota {
    return new MenuCuota(item, item.nombre);
  }
}
